import { HERO_RENTAL_ADDRESS } from '@wolffun/shared/constants';
import { getCurrentConnector, walletClient } from '@wolffun/shared/src/utils/walletClient';
const address = HERO_RENTAL_ADDRESS;
const abi = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'CancelLending',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'previousOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'bid',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }],
  name: 'SuccessfulLending',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'renter',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'fee',
    type: 'uint256'
  }],
  name: 'SuccessfulRenting',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'bid',
    type: 'uint256'
  }],
  name: 'UnlockHero',
  type: 'event'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }],
  name: 'cancelLending',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'feeToAddress',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'ids',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_price',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'lending',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'nft',
  outputs: [{
    internalType: 'contract IThetanHero',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'paymentToken',
  outputs: [{
    internalType: 'contract IERC20',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'renounceOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_price',
    type: 'uint256'
  }],
  name: 'renting',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'rentingTokens',
  outputs: [{
    internalType: 'bool',
    name: 'isExist',
    type: 'bool'
  }, {
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    internalType: 'bool',
    name: 'rented',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_feeToAddress',
    type: 'address'
  }],
  name: 'setFeeToAddress',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'token',
    type: 'address'
  }],
  name: 'setNFT',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'token',
    type: 'address'
  }],
  name: 'setPaymentToken',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }],
  name: 'setSigner',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_transactionFee',
    type: 'uint256'
  }],
  name: 'setTransactionFee',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'signer',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'transactionFee',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_bid',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'bool',
    name: '_old',
    type: 'bool'
  }, {
    internalType: 'uint256',
    name: '_expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'unlockHero',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_price',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'verifyLendingSig',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_bid',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'bool',
    name: '_old',
    type: 'bool'
  }, {
    internalType: 'uint256',
    name: '_expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'verifyUnlockSig',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}];

const getContract = () => {
  if (walletClient) {
    return getCurrentConnector().getContract({
      address,
      contractInterface: abi
    });
  }

  return undefined;
};

export default {
  address,
  abi,
  getContract
};